import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IComment } from "./props";

interface IState {
  isLoading: boolean;
  isActionLoading: boolean;
  documentCount: number;
  annoucementCount: number;
  comments: IComment[];
  pageAmount: number;
}

const initialState: IState = {
  isLoading: false,
  isActionLoading: false,
  documentCount: 0,
  annoucementCount: 0,
  comments: [],
  pageAmount: 0,
};

const CommentsSlice = createSlice({
  name: "count",
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setActionLoading: (state, action: PayloadAction<boolean>) => {
      state.isActionLoading = action.payload;
    },
    setDocumentCount: (state, action: PayloadAction<number>) => {
      state.documentCount = action.payload;
    },
    setAnnoucementCount: (state, action: PayloadAction<number>) => {
      state.annoucementCount = action.payload;
    },
    setComments: (state, action: PayloadAction<IComment[]>) => {
      state.comments = action.payload;
    },
    setPageAmount: (state, action: PayloadAction<number>) => {
      state.pageAmount = action.payload;
    },
    // comment actions
    updateAllComments: (state, action: PayloadAction<Partial<IComment>>) => {
      state.comments = state.comments.map((comment) => ({
        ...comment,
        ...action.payload,
      }));
    },
    updateCommentById: (
      state,
      action: PayloadAction<{ id: string; changes: Partial<IComment> }>
    ) => {
      const { id, changes } = action.payload;
      const comment = state.comments.find((c) => c.id === id);
      if (comment) {
        Object.assign(comment, changes);
      }
    },
    deleteCommentById: (state, action: PayloadAction<string>) => {
      const removeId = action.payload;

      state.comments = state.comments.filter((c) => c.id !== removeId);

      const filterNested = (items: IComment[]): IComment[] => {
        return items
          .filter((item) => item.id !== removeId)
          .map((item) => ({
            ...item,
            comments: item.comments ? filterNested(item.comments) : undefined,
          }));
      };

      state.comments = filterNested(state.comments);
    },
  },
});

export const {
  setLoading,
  setActionLoading,
  setDocumentCount,
  setAnnoucementCount,
  setComments,
  setPageAmount,
  // comment actions
  updateCommentById,
  updateAllComments,
  deleteCommentById,
} = CommentsSlice.actions;
export const CommentsReducer = CommentsSlice.reducer;
